var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiv10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.78125,
    width: 46,
    height: 46,
    rx: 13,
    fill: "#06BA63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2060_58489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7456 8.67188C14.824 8.67188 8.35938 15.9504 8.35938 24.0274C8.35938 26.6071 9.1118 29.2636 10.4324 31.6898C10.6781 32.089 10.7088 32.5957 10.5399 33.0718L9.51104 36.5114C9.28071 37.3406 9.98706 37.9548 10.7702 37.7091L13.872 36.7878C14.7166 36.5114 15.3768 36.8646 16.1615 37.3406C18.4034 38.6612 21.1966 39.3368 23.7149 39.3368C31.3312 39.3368 39.0704 33.4556 39.0704 23.9813C39.0704 15.8122 32.4675 8.67188 23.7456 8.67188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5983 26.0091C15.5234 26.0091 14.6328 25.1185 14.6328 24.0436C14.6328 22.9534 15.5081 22.0781 16.5983 22.0781C17.6885 22.0781 18.5638 22.9534 18.5638 24.0436C18.5638 25.1185 17.6885 25.9937 16.5983 26.0091ZM23.6777 26.0093C22.5875 25.994 21.7122 25.1187 21.7122 24.0285C21.7122 22.9536 22.6028 22.063 23.6777 22.0783C24.768 22.0783 25.6432 22.9536 25.6432 24.0438C25.6432 25.1187 24.768 26.0093 23.6777 26.0093ZM28.7909 24.044C28.7909 25.1189 29.6661 26.0095 30.7564 26.0095C31.8466 26.0095 32.7219 25.1189 32.7219 24.044C32.7219 22.9538 31.8466 22.0785 30.7564 22.0785C29.6661 22.0785 28.7909 22.9538 28.7909 24.044Z",
    fill: "#06BA63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2060_58489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(7.5 7.78125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv10);
export default __webpack_public_path__ + "static/media/div10.966808f96d25568fa6b592fd56897beb.svg";
export { ForwardRef as ReactComponent };